var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.147.314L.22.23a.75.75 0 01.976-.073L1.28.23l4.47 4.469 4.47-4.47a.75.75 0 111.06 1.06L6.811 5.76l4.47 4.47a.75.75 0 01.072.977l-.073.084a.75.75 0 01-.976.073l-.084-.073-4.47-4.47-4.47 4.47a.75.75 0 01-1.06-1.06l4.47-4.47L.22 1.29A.75.75 0 01.146.314z",
    fill: "#4E8209"
  })));
}
export default SvgFormClose;